import React from "react";
import { useSiteContent } from "@/lib/siteContent";

const STOCK_FOUNDER_IMG =
  "https://images.pexels.com/photos/7580822/pexels-photo-7580822.jpeg?auto=compress&cs=tinysrgb&w=900";

export const Founder = () => {
  const { content } = useSiteContent();
  const founderImg = content.founder_image || STOCK_FOUNDER_IMG;
  const hats = content.founder_hats || [];
  const paragraphs = content.founder_paragraphs || [];
  const firstName = content.founder_name?.split(" ")[0] || "Harshita";

  return (
    <section id="founder" className="py-24 lg:py-32 bg-[#FDFBF7] relative">
      <div className="absolute inset-0 grain" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5 relative">
          <div className="relative max-w-md">
            <div className="absolute -top-5 -left-5 w-full h-full bg-[#CBA358]" />
            <img
              src={founderImg}
              alt={`${content.founder_name} — Founder`}
              loading="lazy"
              className="relative w-full aspect-[4/5] object-cover"
            />
          </div>
          {content.founder_mission_quote && (
            <div className="mt-8 max-w-md bg-[#0A2342] text-[#FDFBF7] p-7">
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#CBA358]">
                My Mission
              </div>
              <p className="mt-3 font-display italic text-xl leading-snug text-balance">
                &ldquo;{content.founder_mission_quote}&rdquo;
              </p>
              <div className="mt-5 font-script text-3xl text-[#CBA358]">
                &mdash; {firstName}
              </div>
            </div>
          )}
        </div>

        <div className="lg:col-span-7">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#CBA358] font-semibold">
            {content.founder_eyebrow}
          </div>
          <h2 className="font-display text-4xl lg:text-5xl mt-4 text-[#0A2342] leading-[1.05] text-balance">
            Meet <span className="italic font-medium">{content.founder_name}</span>
          </h2>
          {content.founder_subtitle && (
            <p className="mt-2 text-sm uppercase tracking-[0.18em] text-[#5C636A]">
              {content.founder_subtitle}
            </p>
          )}

          <div className="mt-8 space-y-5 font-body text-[#3C4147] text-[17px] leading-[1.75] max-w-2xl">
            {paragraphs.map((p, i) => (
              <p
                key={i}
                className={i === paragraphs.length - 1 ? "text-[#0A2342]" : ""}
              >
                {p}
              </p>
            ))}
          </div>

          {hats.length > 0 && (
            <div className="mt-10">
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#5C636A] mb-4">
                Wear many hats &middot; One purpose
              </div>
              <div className="flex flex-wrap gap-2">
                {hats.map((h, i) => (
                  <span
                    key={i}
                    className="px-4 py-2 border border-[#0A2342] text-[#0A2342] text-xs uppercase tracking-wider hover:bg-[#0A2342] hover:text-[#FDFBF7] transition-colors cursor-default"
                  >
                    {h}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Founder;
